import React from "react";
import "./is8.scss";
import { useStaticQuery, graphql, Link } from "gatsby";
import Img from "gatsby-image";
export default () => {
  const data = useStaticQuery(graphql`
    query testt {
      img1: file(
        relativePath: { eq: "components/pages/index/is8/1.jpg" }
      ) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img2: file(relativePath: { eq: "components/pages/index/is8/2.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img3: file(relativePath: { eq: "components/pages/index/is8/3.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
      img4: file(relativePath: { eq: "components/pages/index/is8/4.jpg" }) {
        childImageSharp {
          fluid {
            ...GatsbyImageSharpFluid
          }
        }
      }
    }
  `);
  return (
    <div className="is8">
      <h3>Happy Students</h3>
      <div className="res-box">
        <div className="res-img">
          <Img fluid={data.img1.childImageSharp.fluid} />
        </div>
        <div className="res-img">
          <Img fluid={data.img2.childImageSharp.fluid} />
        </div>
        <div className="res-img">
          <Img fluid={data.img3.childImageSharp.fluid} />
        </div>
        <div className="res-img">
          <Img fluid={data.img4.childImageSharp.fluid} />
        </div>
      </div>
    </div>
  );
};
